import { messages as indonesianMessages } from "./id";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";

const messages = {
	...indonesianMessages,
	...englishMessages,
	...spanishMessages,
};

export { messages };
